import { render, staticRenderFns } from "./OmnichannelPage.vue?vue&type=template&id=1112845e&scoped=true"
import script from "./OmnichannelPage.vue?vue&type=script&lang=js"
export * from "./OmnichannelPage.vue?vue&type=script&lang=js"
import style0 from "./OmnichannelPage.vue?vue&type=style&index=0&id=1112845e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1112845e",
  null
  
)

export default component.exports